import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProjectService {
    private http = inject(HttpClient);
    private apiUrl = '/api/reporting/projects';

    // Get all projects
    getAll(): Observable<any[]> {
        return this.http.get<any[]>(this.apiUrl);
    }

    // Get project by ID
    getById(id: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/${id}`);
    }

    // Create new project
    create(project: any): Observable<any> {
        return this.http.post(this.apiUrl, project);
    }

    // Update project
    update(id: string, project: any): Observable<any> {
        return this.http.put(`${this.apiUrl}/${id}`, project);
    }

    // Delete project
    delete(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${id}`);
    }

    // Update project status
    updateStatus(id: string, status: number): Observable<any> {
        return this.http.patch(`${this.apiUrl}/${id}/status`, { status });
    }
}
